<div class="row">
  <div *ngIf="title || description" class="col-12">
    <h3 class="pb-3" *ngIf="title">{{ title }}</h3>
    <p class="pb-3" *ngIf="description && !easyMode">{{ description }}</p>
  </div>
</div>
<app-partner-form #partnerForm [(partner)]='partner' (eventFormValid)="partnerFormValid()"
  (eventFormInvalid)="partnerFormInvalid()" (eventFormDirty)="partnerFormDirty()"
  (eventFormNotDirty)="partnerFormNotDirty()" [minAge]="minAge" [showRepeatEmail]="showRepeatEmail"
  [showPartnerTitle]="true" [showGender]="showGender" [showZip]="showAddress || showZip" [easyMode]="easyMode"
  [showPartnerNames]="showFullName" [showAddress]="showAddress" [showPhone]="showPhone" [showInternalReference]="showInternalReference"
  [fieldsConfigurations]="fieldsConfigurations">
</app-partner-form>
<app-partner-password *ngIf="showPassword && isFieldAvailable('password')"
  [showOldPasswordConfirmation]="showOldPasswordConfirmation" [password]="password"
  (eventFormValid)="partnerPasswordFormValid()" (eventFormInvalid)="partnerPasswordFormInvalid()"
  (eventFormDirty)="partnerFormDirty()" (eventFormNotDirty)="partnerFormNotDirty()"
  [easyMode]="easyMode && !repeatPassword"></app-partner-password>
<div *ngIf="(showMediaAgree || showEmailAgree || showPhoneAgree || showAGBAgree) && !easyMode"
  class="row justify-content-center">
  <div class="col-8 text-center">
    <hr>
  </div>
</div>
<div *ngIf="showMediaAgree && isFieldAvailable('showMediaAgree')" class="row">
  <div class="col-12">
    <app-checkbox
      [title]='"I agree that the operator uses video and audio material recorded by the operator during my stay, either in whole or in part, free of charge, exclusively without restrictions regarding time and place, and as often as desired on TV or on the internet or that the operator transfers this right to third parties. Legitimate interests of the persons recorded are preserved" | translate'
      [name]="'offersMedia'" [(ngModel)]="partner.offersMedia"></app-checkbox>
  </div>
</div>
<div *ngIf="showEmailAgree && isFieldAvailable('showEmailAgree')" class="row email-checkbox">
  <div class="col-12">
    <app-checkbox
      [title]='"I agree to be contacted by the operator regarding news, events etc. via the e-mail address i provided." | translate'
      [name]="'offersEmail'" [(ngModel)]="partner.offersEmail"></app-checkbox>
    {{ 'Note: Your email address will not be shared with third parties and will not be used for any other purpose.' |
    translate }}
    <br>
    {{ 'You can revoke your consent at any time by unsubscribing from the list (notes are included in each e-mail).'
    | translate }}
    <br>
    {{ 'Further information can be found in our ' | translate }}
    <a (click)="onPrivacyPolicyClick()">{{ 'privacy policy' | translate }}</a>.
  </div>
</div>
<div *ngIf="showPhoneAgree && isFieldAvailable('showPhoneAgree')" class="row">
  <div class="col-12">
    <app-checkbox [title]='"I agree to receive information about news, events etc. by telephone." | translate'
      [name]="'offersPhone'" [(ngModel)]="partner.offersPhone"></app-checkbox>
  </div>
</div>
<div *ngIf="showAGBAgree" class="row">
  <div class="col-12">
    <app-checkbox [name]="'termsOfUseAndPrivacyAccepted'" [(ngModel)]="partner.termsOfUseAndPrivacyAccepted"
      (checkboxChanged)="agbAgreeChanged($event)" appRequiredTrue required></app-checkbox>
    <span class="agb-link" [ngClass]="partner.termsOfUseAndPrivacyAccepted ? '': 'agb-link-required'">
      {{ 'ACCEPTED_AGB_PART_1' | translate }} <a class="link" [attr.href]="termsConditionsLink" target="_blank"><u [ngClass]="{'touch-zone-vu-mode': isVuMode}"
          (click)="showAGB()" [ngClass]="partner.termsOfUseAndPrivacyAccepted ? '': 'agb-link-required'">{{ 'AGB_LINK' |
          translate }}</u></a>
      {{ 'ACCEPTED_AGB_PART_2' | translate }} <a class="link" [attr.href]="privacyLink" target="_blank"><u [ngClass]="{'touch-zone-vu-mode': isVuMode}"
          (click)="showPrivacyPolicy()" [ngClass]="partner.termsOfUseAndPrivacyAccepted ? '': 'agb-link-required'">{{
          'PRIVACY_POLICY_LINK' | translate }}</u></a>{{ 'ACCEPTED_AGB_PART_3' | translate }}.
    </span>
  </div>
</div>
<div *ngIf="showLoginUrl" class="row">
  <div class="col-12">
    <div class="list-group create-account-callout">
      <div class="list-group-item list-group-item-light">
        {{ 'Do you already have an account?' | translate }} <a (click)="onLogin()">{{'Sign in now' | translate}}</a>
      </div>
    </div>
  </div>
</div>
